export enum Partner {
    Microsoft = 'Microsoft',
    Yahoo = 'Yahoo'
}